var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.hidefccBase)?_c('fccBaseLayout',[_c('router-view')],1):_vm._e(),(_vm.$route.meta.hidefccBase)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }